import { ReactElement } from 'react';
import { ENotRealSports } from 'interfaces/not-real-sports';
import { DropdownStyled } from './style';
import { MarketsFilter } from 'components/SportsbookCompetitionViewCollapse/__partials/MarketFilter';
import { CompetitionSkeleton } from 'components/UI/Skeletons/CompetitionSkeleton';
import { SportsbookGameListHeaderSkeleton } from 'newcomponents/Shared/sportsbook/SportsbookGameListHeaderSkeleton';

export const DesktopGameListSkeleton = ({
  isLive,
  category
}: {
  category?: string | ENotRealSports;
  isLive: boolean;
}): ReactElement => {
  return (
    <>
      <DropdownStyled>
        <SportsbookGameListHeaderSkeleton isLive={isLive} />
        <MarketsFilter />
      </DropdownStyled>
      <CompetitionSkeleton category={category} />
    </>
  );
};
